import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://api.hrflow.ai/v1',
    headers: {
        'X-API-KEY': 'askr_07106bbd5bc856f7e9656e0ee652cfc4'
    }
});

export default instance;